<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <swb-offices></swb-offices>
  <swb-office-contacts></swb-office-contacts>
  <swb-contacts-map></swb-contacts-map>
  <swb-sponsored></swb-sponsored>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <swb-about></swb-about>
  <swb-partners></swb-partners>
</div>
<router-outlet></router-outlet>